import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/eco-credits`;

const EcoCreditsManager = {
  async redeemEcoCredits(userId) {
    const { data } = await axios.post(`${BASE_URL}/redeem/${userId}`);

    // Handle API error inside service
    if (data.errorCode) {
      throw new Error(data.responseMessage || "Redemption failed.");
    }

    return data.responseData; // CouponDTO object
  },

    // Plant a tree using eco credits
    async plantTree(userId, creditsUsed = 500, message = "") {
      const { data } = await axios.post(
        `${BASE_URL}/plant-tree/${userId}`,
        { creditsUsed, message }  // Request body
      );
    
      if (data.errorCode) {
        throw new Error(data.responseMessage || "Planting failed.");
      }
    
      return data.responseData;
    },
};

export default EcoCreditsManager;
